module.exports = __webpack_public_path__ + "img/epitech.1ed835e1.jpg";